/* JHSN cart VIP+ card (Icons Footwear): collapsible ATHENA-style card. Join = add membership with selling plan + apply code; leave = remove membership + clear code (cart/update.js with an empty discount). The opt-out is remembered by jhsn-cart-fix.js (source 'cart-vip'). */
if (!customElements.get('cart-vip')) {
  customElements.define(
    'cart-vip',
    class CartVip extends BaseElement {
      connectedCallback() {
        super.connectedCallback();
        try { if (sessionStorage.getItem('jhsnVipOpen') === '1') this.setAttribute('data-expanded', 'true'); } catch (e) { /* ignore */ }
        this.on(this, 'click', this.onClick.bind(this));
        this.on(this, 'change', this.onChange.bind(this));
      }

      get joined() { return this.getAttribute('data-joined') === 'true'; }

      showError(message) {
        const error = this.querySelector('.jc-vip__error');
        if (!error) return;
        error.textContent = message || '';
        error.hidden = !message;
      }

      async setCode(code) {
        try {
          await fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js'), { credentials: 'same-origin' });
        }
        catch (e) { /* ignore */ }
      }

      onClick(event) {
        const head = event.target.closest('.mv__head');
        if (head) {
          const open = this.getAttribute('data-expanded') !== 'true';
          this.setAttribute('data-expanded', open ? 'true' : 'false');
          try { open ? sessionStorage.setItem('jhsnVipOpen', '1') : sessionStorage.removeItem('jhsnVipOpen'); } catch (e) { /* ignore */ }
          return;
        }
        const button = event.target.closest('.mv__btn');
        if (button) {
          event.preventDefault();
          if (!this.joined) this.update(true);
        }
      }

      onChange(event) {
        const radio = event.target.closest('.mv__radio-vip, .mv__radio-guest');
        if (!radio) return;
        if (radio.classList.contains('mv__radio-vip') && !this.joined) this.update(true);
        else if (radio.classList.contains('mv__radio-guest') && this.joined) this.update(false);
      }

      async update(join) {
        if (this.getAttribute('aria-busy') === 'true') return;
        const variantId = parseInt(this.getAttribute('data-variant-id'), 10);
        const planId = parseInt(this.getAttribute('data-plan-id'), 10);
        const sectionId = this.getAttribute('data-section-id');
        const code = this.getAttribute('data-code');
        this.setAttribute('aria-busy', 'true');
        this.showError('');
        try {
          let cart;
          if (join) {
            await this.setCode(code);
            const added = await (await fetch(theme.routes.cart_add_url, {
              ...theme.utils.fetchConfig('javascript'),
              body: JSON.stringify({ items: [{ id: variantId, quantity: 1, selling_plan: planId }], sections: [sectionId], sections_url: window.location.pathname })
            })).json();
            if (added.status) throw new Error(added.description || added.message || 'add failed');
            cart = await (await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET') })).json();
            cart['sections'] = added['sections'];
          }
          else {
            const removed = await (await fetch(theme.routes.cart_change_url, {
              ...theme.utils.fetchConfig(),
              body: JSON.stringify({ id: String(variantId), quantity: 0 })
            })).json();
            if (removed.status) throw new Error(removed.description || 'change failed');
            // clear the VIP+ code so the member discount does not stay on the cart
            cart = await (await fetch('/cart/update.js', {
              ...theme.utils.fetchConfig(),
              body: JSON.stringify({ discount: '', sections: [sectionId], sections_url: window.location.pathname })
            })).json();
            if (cart.status) throw new Error(cart.description || 'update failed');
          }
          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-vip', cart });
        }
        catch (error) {
          console.error(error);
          this.showError('Sorry, we could not update your membership. Please try again.');
          this.removeAttribute('aria-busy');
        }
      }
    }
  );
}
